<template>
    <div>
        <modal v-if="modalTriggerConfirmCCRemove" @close="modalTriggerConfirmCCRemove = false">
            <h3 slot="header">Removing Closed Captioning File</h3>
            <div class="content" slot="body">
                <div v-if="video.CCFilename">Are you sure you want to remove {{video.CCFilename}}?</div>
                <div v-else>Are you sure you want to remove this item?</div>
            </div>
            <div class="form-group-submit clearfix" slot="footer">
                <button class="btn btn-cancel btn-transparent pull-left" @click="modalTriggerConfirmCCRemove = false">Cancel</button>
                <button class="pull-right" @click="removeCCFile(video.id)">Yes, Remove</button>
            </div>
        </modal>

        <div v-if="video.status != 'Upload Failed'" class="closed-caption-upload-wrapper">
            <div id="closed_caption" class="filename d-flex align-items-center" v-if="video.CCFileUrl">
                <span class="pr-3 pointer" @click.prevent="activateDeleteCCFilePopup(video, index)"><i class="fa fa-trash"></i></span>
                <span class="cc-filename">{{ video.CCFilename }}</span>
            </div>
            <vue-dropzone  class="video-placeholder d-block" v-if="!video.CCFileUrl && video.id" :ref="'myVueDropzone'+index" :id="'dropzone'+index" :options="dropzoneOptions" v-on:vdropzone-success="successCallback" v-on:vdropzone-sending="sendingCallback" v-on:vdropzone-file-added="acceptCallback"></vue-dropzone>
            <a v-if="!video.CCFileUrl && !video.uploadingCC" href="#" class="btn btn-primary displaybloc cc-upload-table-button" @click.prevent="activateDropzone(index)">Upload</a>
        </div>
    </div>
</template>

<script>
import modal from './Modal.vue';
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import AWS from 'aws-sdk/global';
import S3 from 'aws-sdk/clients/s3';
import axios from 'axios';

export default {
    components: {vueDropzone, modal},
    props: ['videoData', 'indexVal'],
    data() {
        return {
            video: this.videoData,
            index: this.indexVal,
            modalTriggerConfirmCCRemove: false,
            dropzoneOptions: {
                thumbnailWidth: 150,
                autoQueue: false,
                // The URL will be changed for each new file being processing
                url: '/',
                maxFilesize: 300000, // 300GB
                timeout: 172800000, // 48 hours in miliseconds
                // Since we're going to do a `PUT` upload to S3 directly
                method: 'put',
                dictDefaultMessage: '',
                // Hijack the xhr.send since Dropzone always upload file by using formData
                // ref: https://github.com/danialfarid/ng-file-upload/issues/743
                // sending (file, xhr) {
                //     let _send = xhr.send
                //     xhr.send = () => {
                //         _send.call(xhr, file)
                //     }
                // },
                // Upload one file at a time since we're using the S3 pre-signed URL scenario
                parallelUploads: 10,
                uploadMultiple: false,
                // Content-Type should be included, otherwise you'll get a signature
                // mismatch error from S3. We're going to update this for each file.
                header: '',
                // We're going to process each file manually (see `accept` below)
                autoProcessQueue: true,
                acceptedFiles: '.vtt,.scc',
                // accept: this.acceptCallback, // use our custom acceptCallback
                // canceled : this.abortUpload,
                // complete: this.completeUpload,
                sending: function(file, xhr) {
                    var _send = xhr.send;
                    xhr.send = function() {
                        _send.call(xhr, file);
                    }
                }
            }
        }
    },
    methods: {
        activateDeleteCCFilePopup(video) {
            let app = this;
            app.modalTriggerConfirmCCRemove = true;
        },
        sendFileStatus(file) {
            let app = this;
            let vfo_id = app.video.id;
            let actionUrl = '/video/update/' + vfo_id;
            console.log('send file status', file);
            axios.post(actionUrl, {
                id: vfo_id,
                CCFileUrl: file.s3key,
                CCFilename: file.name
            })
                .then(function(response) {
                    app.video.CCFilename = file.name;
                    app.video.CCFileUrl = file.s3key;
                    app.video.cc_status = response.data.cc_status;
                }).catch(function (error) {
                // handle error
                console.log('CC error', error)
                app.video.CCFileUrl = '';
            });
        },
        successCallback(file, response){
            console.log('success', file);
            this.sendFileStatus(file);
        },
        sendingCallback(file, xhr, formData) {
            xhr.timeout = 99999999;
        },
        acceptCallback(file, dzone) {
            console.log('acceptCallback method');
            let vm = this;
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
            var filename = `captionfile_${vm.submitterid}_${Date.now()}.${ext}`;

            // get signed url for upload
            let app = this;
            axios.get('/api/signed_url', {
                params: {
                    filename: filename,
                    filetype: file.type,
                    uploadtype: 'caption'
                }
            })
                .then(function(response) {
                    file.s3key = response.data.s3_key;   // returned by api call
                    app.$refs['myVueDropzone' + app.index].dropzone.URL = response.data.signed_url;
                    app.$refs['myVueDropzone' + app.index].dropzone.options.url = response.data.signed_url;
                    app.$refs['myVueDropzone' + app.index].dropzone.processFile(file);
                })

            // options for the managed upload for this accepted file
            // define the bucket, and the S3 key the file will be stored as

            //this.sendFileStatus(file);
            // automatically start the uploads (comment it out if you want to use the start upload button)
            //setTimeout(() => vm.dropzone.processFile(file))
        },
        sendFile(file, dzelement) {
            console.log('sending file through AWS sdk');
            file.s3upload.send(function(err, data) {
                if (err) {
                    console.log(err.message);
                    dzelement.emit("error", file, err.message);
                } else {
                    console.log('complete');
                    file.status = Dropzone.SUCCESS;
                    dzelement.emit("success", file, 'success', null);
                    dzelement.emit("complete", file);

                }
            });

            // listen to the AWS httpUploadProgress event, and emit an equivalent Dropzone event
            file.s3upload.on('httpUploadProgress', function(progress) {
                if (progress.total) {
                    var percent = ((progress.loaded * 100) / progress.total);
                    dzelement.emit('uploadprogress', file, percent, progress.loaded);
                }
            });
        },
        activateDropzone: function(index) {
            // console.log(index, 'index for dropzone')
            this.activeVideoIndex = index;
            $('#dropzone' + index).click();
            this.video.uploadingCC = true;
        },
        removeCCFile: function(vid) {
            let app = this;
            let vfo_id = app.video.id;
            let actionUrl = '/video/update/' + vfo_id;

            axios(
                {
                    method: 'POST',
                    url: actionUrl,
                    data: {
                        id: vid,
                        CCFileUrl: '',
                        CCFilename: '',
                        cc_status: '',
                        cc_file_offset: ''
                    }
                }).then(function(response) {
                app.video.CCFileUrl = '';
                app.video.CCFilename = '';
                app.video.cc_status = '';
                app.video.cc_file_offset = '';
                app.modalTriggerConfirmCCRemove = false;
                app.video.uploadingCC = false;
            }).catch(function (error) {
                // handle error
                console.log('This is the error returned', error);
            });
        }
    }
}
</script>
